/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\LiCustom\LiCustom.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday August 2nd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday August 2nd 2023 11:39:47 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Styles from "Content/LiCustom/LiCustom.module.css";
import { Tooltip } from "@mui/material";
import translator from "MultiLanguage/TranslationWrapper";

type LiCustomProps = {
    data: string[] | null;
    title: string;
    onClick?: Function;
    translateKey?: string;
    tooltipKey?: string;
};

function LiCustom(props: LiCustomProps) {
    let myLi = props.data?.map((item, index) =>  {
        if (props.tooltipKey)
            return (<Tooltip followCursor title={translator.decode(`${props.tooltipKey}.${item}`)}>
                <li key={item + index} className={`${Styles.labels}`} onClick={()=> props.onClick ? props.onClick(item): {}}>
                    {
                        props.translateKey ?
                        translator.decode(`${props.translateKey}.${item}`)
                        : item
                    }
                </li>
                </Tooltip>)
        else
            return (<li key={item + index} className={`${Styles.labels}`} onClick={()=> props.onClick ? props.onClick(item): {}}>{
                props.translateKey ?
                translator.decode(`${props.translateKey}.${item}`)
                : item
            }</li>)
    });

    return (
        <div className={`${Styles.tagHolder}`}>
            <h4>{props.title}</h4>
            <ul className={`${Styles.tag}`}>
                {myLi}
            </ul>
        </div>
    );
};

export default LiCustom;
